import { Button } from '@cibli/shared';
import { Trash2 } from 'lucide-react';
import React from 'react';

interface NumberedItemProps {
  index: number;
  children: React.ReactNode;
  onDelete?: () => void;
  showDelete?: boolean;
  className?: string;
}

const NumberedItem: React.FC<NumberedItemProps> = ({
  index,
  children,
  onDelete,
  showDelete = false,
  className,
}) => {
  return (
    <div className={`flex gap-3 w-full min-w-0 ${className}`}>
      <div className="flex shrink-0 items-center justify-center size-7 bg-primary text-white rounded-full text-sm font-medium">
        {index + 1}
      </div>
      <div className="flex-1 min-w-0">{children}</div>
      {showDelete && onDelete && (
        <Button
          type="button"
          variant="secondary"
          size="icon"
          onClick={onDelete}
          className="shrink-0 text-destructive hover:text-destructive/90 h-12 w-12"
        >
          <Trash2 className="h-5 w-5" />
        </Button>
      )}
    </div>
  );
};

export default NumberedItem;
